/**
 * Need and Gap Analysis
 */

export { NeedAndGapAnalysisContainer } from './containers'
